module.exports = __webpack_public_path__ + "img/tacoma.92001dfc.png";